import React, { FunctionComponent } from 'react';
import { Container, Image } from 'semantic-ui-react';
import { BarChart, Bar, YAxis, XAxis, Cell } from 'recharts';
import { prop, apply, map, addIndex, isNil } from 'ramda';

import { Segment } from 'components/Charts/Demographics/Demographics.helper';
import NoDataImage from 'assets/icons/NoData/age.svg';

import SectionHeader from '../Header';

type LabelProps = {
  x: number;
  y: number;
  value: number;
};

type Props = {
  ageGroups: Segment[];
  isAnimationActive?: boolean;
  title?: string;
  width?: number;
  height?: number;
};

const mapIndexed = addIndex<any>(map);

const findMax = (ageGroups: any) =>
  apply(Math.max, map(prop('percent'), ageGroups));

const CustomizedLabel = ({ x, y, value }: LabelProps) => (
  <text
    x={x}
    y={y - 10}
    fontSize=".875rem"
    textAnchor="start"
    stroke={'rgba(74,74,74, .8)'}
  >
    {`${Math.ceil(value)}%`}
  </text>
);

const renderCells = (max: number) =>
  mapIndexed(({ percent }: any, index: number) => (
    <Cell
      key={`cell-${index}`}
      fill={percent === max ? '#683caf' : '#d7caed'}
    />
  ));

const Age: FunctionComponent<Props> = ({
  ageGroups,
  title,
  width = 400,
  height = 350,
  isAnimationActive = true,
}) => (
  <Container>
    {title && <SectionHeader title={title} />}
    {isNil(ageGroups) ? (
      <Image src={NoDataImage} />
    ) : (
      <BarChart
        data={ageGroups}
        margin={{ top: 0, right: 15, left: 0, bottom: 0 }}
        barCategoryGap={1}
        width={width}
        height={height}
      >
        <YAxis type="number" hide />
        <XAxis
          type="category"
          width={65}
          dataKey="segmentLabel"
          tick={{ stroke: 'rgba(74,74,74, .3)', fontSize: '.75rem' }}
          stroke={'rgba(74,74,74, .8)'}
        />

        <Bar
          dataKey="percent"
          barSize={28}
          label={CustomizedLabel}
          isAnimationActive={isAnimationActive}
        >
          {renderCells(findMax(ageGroups))(ageGroups as any)}
        </Bar>
      </BarChart>
    )}
  </Container>
);

export default Age;
